import { Component, Input, Output, EventEmitter, OnInit, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';

declare interface DataTable {
  headerRow: string[];
  footerRow: string[];
  dataRows: string[][];
}

declare interface Event {
  evento: '';
  id: null;
  rep_id: null;
}

declare var $: any;

@Component({
  selector: 'app-weight-table',
  templateUrl: './weight-table.component.html',
  styleUrls: ['./weight-table.component.css']
})
export class WeightTableComponent implements OnInit, AfterViewInit {

  @Input() assigned: boolean = false;
  @Input() dataTable: DataTable;

  @Output() out: EventEmitter<Event>;

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
  ) {
    this.out = new EventEmitter;
  }

  saveEmit(accion, id, rep = null) {
    var send = {
      evento: accion,
      id: id,
      rep_id: rep
    };
    this.out.emit(send);
  }

  ngOnInit() {}

  change_location(){
    console.log("Hey");
  }

  ngAfterViewInit() {
    $('#weightdatatables').DataTable({
      'order': [[ 0, 'desc' ]],
      dom: 'Bflrtip',
        buttons: [
          /*{
            extend: 'copy',
            exportOptions: {
              columns: ':visible'
            }
          },*//*
          {
            extend: 'csv',
            exportOptions: {
              columns: ':visible'
            }
          },*/
          {
            extend: 'excel',
            text: '<i class="fa fa-file-excel-o"></i>',
            titleAttr: 'Excel',
            className: 'btn btn-sm btn-outline-success',
            exportOptions: {
              columns: ':visible'
            }
          },
          {
            extend: 'pdf',
            text: '<i class="fa fa-file-pdf-o"></i>',
            titleAttr: 'PDF',
            className: 'btn btn-sm btn-outline-danger',
            exportOptions: {
              columns: ':visible'
            }
          },
          {
            extend: 'print',
            text: '<i class="fa fa-print" aria-hidden="true"></i>',
            titleAttr: 'print',
            className: 'btn btn-sm btn-outline-primary',
            exportOptions: {
              columns: ':visible'
            }
          },
          {
            extend: 'colvis',
            text: '<i class="fa fa-columns" aria-hidden="true"></i>',
            className: 'btn btn-sm btn-outline-info',
            titleAttr: 'Column visibility'
          },
        ],
      'pagingType': 'full_numbers',
      'lengthMenu': [
        [5, 10, 25, 50, 100, 200, 500, 1000, -1],
        [5, 10, 25, 50, 100, 200, 500, 1000, 'All']
      ],
      responsive: true,
      language: {
        search: '_INPUT_',
        searchPlaceholder: 'Search records',
      }

    });
  }

}
